import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { connect } from "react-redux";
import Loader from "../../components/loader";
import Regsiter from "../../containers/SignUp/index";
import { Row, Col } from "antd";
import { AiOutlineTwitter, FaFacebookF, FaLinkedinIn } from "react-icons/all";
import ExpiredLink from "../../containers/SignUp/expiredlink";
import Not_found from "../../containers/SignUp/not_found";
import SurfaceLogo from "../../assets/images/surface-logo.png";

class Routes extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <Suspense fallback={<Loader />}>
        <Switch>
          <React.Fragment>
            {!(
              !!window?.location?.pathname?.includes("expired_link") ||
              !!window?.location?.pathname?.includes("404")
            ) && (
              <Row>
                <Col
                  span={24}
                  style={{ padding: "0.8rem", background: "#383A3D" }}
                >
                  <Row align="middle" justify="space-between">
                    <Col xl={6} lg={8} md={8} xs={24} sm={24}>
                      <img width="60%" src={SurfaceLogo} />
                    </Col> 
                  </Row>
                </Col>
              </Row>
            )}
            <Switch>
              <Route exact path="/expired_link" component={ExpiredLink} />
              <Route exact path="/register" component={Regsiter} />
              <Route path="*" render={() => <Redirect to="/register" />} />
            </Switch>
            {/* <Switch>
              <Route exact path='/expired_link' render={() => <div></div>}></Route>
              <Route path='*' render={() => <Register />}></Route>
            </Switch> */}
          </React.Fragment>
        </Switch>
      </Suspense>
    );
  }
}

// const ProtectedRoute = ({ enabled, ...props }) => (
//   enabled && <Route {...props} />
// )

export default connect((storeState) => {
  return {
    isAuthenticated: storeState.AuthReducer?.isAuthenticated,
    storeName: storeState.AuthReducer.storeInfo,
  };
})(Routes);
